import { a as t, E as c } from "./keys-b2183e45-74d07070.js";
function T(r, o, e) {
  if (r === null) return 0;
  var u = r + o,
    n = e - 1,
    i = 0;
  return u < i ? n : u > n ? i : u;
}
function l(r) {
  return r === t.UP || r === t.LEFT ? -1 : r === t.DOWN || r === t.RIGHT ? 1 : 0;
}
function m(r) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  return r === c.TAB && o ? -1 : r === c.TAB ? 1 : 0;
}
export { T as i, m as l, l as o };